<template>
  <div class="loader-body-init">
    <div class="water" />
    <div style="width: 400px; margin-left: -400px; z-index: 100; text-align: center">
      <span>ЗАГРУЗКА, ОЖИДАЙТЕ!</span>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Loader",
  props: ['type']
}
</script>

<style>
.loader-body-init {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.water {
  width: 400px;
  height: 400px;
  background-color: rgb(45,140,0);
  border-radius: 50%;
  position: relative;
  box-shadow: inset 0 0 30px 0 rgba(0,0,0,.5), 0 4px 10px 0 rgba(0,0,0,.5);
  overflow: hidden;
}
.water:before, .water:after{
  content: '';
  position: absolute;
  width:400px;
  height: 400px;
  top:-150px;
  background-color: #fff;
}
.water:before{
  border-radius: 45%;
  background:rgba(255,255,255,.7);
  animation: wave 5s linear infinite;
}
.water:after{
  border-radius: 35%;
  background:rgba(255,255,255,.3);
  animation: wave 5s linear infinite;
}
@keyframes wave{
  0%{
    transform: rotate(0);
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>